import { jsx as m } from "react/jsx-runtime";
import { b as o } from "../FundamentalContext-DHtxz-6Z.js";
import { convertCamelCaseToKebabCase as t } from "../utils/convertCamelCaseToKebabCase.js";
const c = ({ children: e }) => {
  const { currentTheme: r } = o();
  return /* @__PURE__ */ m("div", { className: t(r), children: e });
};
export {
  c as ThemeProvider
};
